// extracted by mini-css-extract-plugin
module.exports = {"box":"TempMessage_box__yVxdp","alert":"TempMessage_alert__TitFU"};